import React from 'react';
import Issues from "./Issues";
import {problemListFields} from "../../network/mockData";

function OpenIssues(props) {
    return (
        <div>
            <Issues
                dataUrl="problem/admin/problems?status=Received&status=InProgress&status=InvestigationRequired"
                tableFields={problemListFields}
                addNewButton={true}
                exportUrl={`problem/admin/problems/excel?status=Received&status=InProgress&status=InvestigationRequired`}
                exportFileName="export_all_open_issues.xls"
            />
        </div>
    );
}

export default OpenIssues;